import { createClient } from '@/shared/api';
import type { SupportModulesQuery, SupportModulesQueryVariables } from '@/shared/api';
import SUPPORT_MODULES_QUERY from '../queries/supportModules';

/**
 * Loads the support modules matching the filter. Runs SUPPORT_MODULES_QUERY and throws the returned message when isSuccess is false, otherwise handing back the supportModules list.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 0.
 * @returns The support modules list.
 */
const fetchSupportModules = async (
  filter: SupportModulesQueryVariables['filter'],
  limit: number = 0,
): Promise<NonNullable<SupportModulesQuery['supportModules']>['supportModules'] | undefined> => {
  const client = createClient();
  const result = await client.query<SupportModulesQuery, SupportModulesQueryVariables>({
    query: SUPPORT_MODULES_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { isSuccess, message, supportModules } = result?.data?.supportModules || {};
  if (!isSuccess) {
    throw new Error(message ?? undefined);
  }
  return supportModules;
};

export default fetchSupportModules;
